export default __webpack_public_path__ + "static/media/unleashtheunderworld.f541059a.png";